import React from 'react'
import { connect } from 'react-redux'
import { BnblPackageDuration } from './BnblPackageDuration'
import { Divider } from './Divider'
import { BnblSteps } from 'components/OfferPage/BnblModal/utils'
import { OfferPackageOptionView } from 'selectors/offerPage/offerPageSelectors'
import { BnblPackageImageAndName } from './BnblPackageImageAndName'
import BnblPackageRooms from './BnblPackageRooms'
import Group from 'components/utils/Group'
import { BnblPackagePreviewVariant } from './BnblPackagePreviewVariant'
import { isMobile } from 'lib/web/deviceUtils'
import { OFFER_TYPE_HOTEL } from 'constants/offer'
import { BnblPackageImageAndNameVariant } from './BnblPackageImageAndNameVariant'
import { useAppSelector } from 'hooks/reduxHooks'

interface MappedProps {
  packageView: OfferPackageOptionView;
}

interface Props {
  offer: App.Offer;
  setStep: (step: BnblSteps) => void;
}

function BnblOneRoomPackage(props: Props & MappedProps) {
  const {
    offer,
    packageView,
    setStep,
  } = props
  const { id: offerId, image } = offer
  const { duration, name: packageName, roomType: { name: roomTypeName }, uniqueKey } = packageView.package

  const isMobileDevice = useAppSelector(state => isMobile(state.config.userAgent.osName))
  const useNewMobileHotelOfferPage = isMobileDevice && offer.type === OFFER_TYPE_HOTEL

  return <Group direction="vertical" gap={16}>
    {!useNewMobileHotelOfferPage && <BnblPackageImageAndName
      image={image}
      packageName={packageName}
      roomTypeName={roomTypeName}
    />}
    {useNewMobileHotelOfferPage && (
      <>
        <BnblPackageImageAndNameVariant
          image={image}
          roomTypeName={roomTypeName}
        />
        <Divider />
        <BnblPackagePreviewVariant
          packageName={packageName}
          setStep={setStep}
        />
      </>
    )}
    <Divider />
    <BnblPackageDuration
      duration={duration}
      setStep={setStep}
    />
    <Divider />
    <BnblPackageRooms
      offerId={offerId}
      packageKey={uniqueKey}
    />
  </Group>
}

function mapStateToProps(state: App.State, ownProps: Props): MappedProps {
  const bnblModalPackages = state.offer.bnblModal[ownProps.offer.id]
  const { packageView } = bnblModalPackages[0]
  return {
    packageView,
  }
}

export default connect(mapStateToProps)(BnblOneRoomPackage)
